var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{attrs:{"data":_vm.ruleData}}),_c('div',{staticStyle:{"text-align":"right"}},[_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("返回")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }